import 'css-chunksrc/client/scenes/organizationalUnitCreation/styles.scss';export default {
  "organizationalUnitCreation": "_organizationalUnitCreation_3roar_1",
  "main": "_main_3roar_5",
  "group": "_group_3roar_12",
  "title": "_title_3roar_16",
  "input": "_input_3roar_23",
  "buttons": "_buttons_3roar_35"
};